import React  from "react";
import { VideoIcon, DownloadIcon } from '../../assets/icons/icon-assets';
import settings from '../../Platform/settings.json';
import { Media } from '../../AVCore/Media';
import { Box, Pressable, Spinner, Heading, HStack, Tooltip } from 'native-base';
import { Linking } from 'react-native';
import { Loc } from '../../App/Loc';
import * as AV from '../../AVCore/AVCore';
import { AHStack } from '../../components/ui';

const SimpleLinkPreview = React.memo( ( { url } : any ) =>
{
    const thumbnailUrl = url?.orgFile?.trim()?.length > 0 ? url?.orgFile : null;

    return (
        <div className="link-preview-wrapper">
            <div className="link-preview-image">
                { thumbnailUrl ? (
                    <img src={ thumbnailUrl } alt={ "Preview" } />
                ) : (
                    <div className="link-icon-container">
                        <LinkIcon />
                    </div>
                ) }
            </div>
            <div className="link-preview-content">
                <Pressable onPress={ () => Linking.openURL( url?.linkURL ) }>
                    <p className="link-url">{ url?.linkURL }</p>
                </Pressable>
            </div>
        </div>
    );
} );

const LinkIcon = React.memo( () =>
{
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="#888888">
            <path d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z" />
        </svg>
    );
} );



const GridView = React.memo( ( { item, setVideoStatus, setVideoItem, isComment = false, isOpening = false, isPreview = false, isConvoReply = false } : any ) =>
{

    const handledocument = async ( item ) =>
    {
        //setIsOpening( true );
        let val = await AV.Media.getFile( item?.media?.mListId, item?.media?.id, item?.media?.storeId );
        if ( val )
        {
            var blobUrl = val;
            var fileName = item?.media?.orgFile;
            var a : any = document.createElement( 'a' );
            a.href = blobUrl;
            a.download = fileName;
            document.body.appendChild( a );
            a.click();
            document.body.removeChild( a );
            //    window.open(val);
        }

        //setIsOpening( false );
    };

    const ProcessingVideo = ({ media, item, setVideoStatus, setVideoItem, isComment, isConvoReply }) => {
        React.useEffect(() => {
            setVideoStatus(media);
            setVideoItem(item);
        }, [media, item, setVideoStatus, setVideoItem]);
    
        return (
            <div className="processing-container">
                <img
                    src={Media.getVideoPicURL(media)}
                    alt="Processing"
                    style={{ objectFit: 'contain', backgroundColor: isComment ? 'white' : '#eeeeee' }}
                />
                <Box
                    position="absolute"
                    top={isConvoReply ? '80%' : "50%"}
                    left={isConvoReply ? '65%' : "50%"}
                    style={{
                        transform: [
                            { translateX: -30 },
                            { translateY: -30 }
                        ]
                    }}
                >
                    <VideoIcon size={isConvoReply ? '30px' : '60px'} color={'white'} />
                </Box>
            </div>
        );
    };


    const posts : any = React.useMemo( () =>
    {
        if ( item?.media?.storeId && ( item?.galleryPost?.length === 0 || item?.galleryPost?.length === undefined ) )
        {
            return [ {
                media: [ item?.media ],
            } ];
        } else if ( item?.galleryPost?.length > 0 )
        {
            const multipleMedia = item?.galleryPost?.map( post => post?.media );
            return [ {
                media: multipleMedia,
            } ];
        }
        return [];
    }, [ item?.media?.storeId, item?.galleryPost, item?.media ] );

    const renderMediaItem = React.useCallback( ( media, index, post, isPreview, isConvoReply ) => (
        <div key={ media?.id + index } className="media-item">
            { ( media?.type?.startsWith( 'image' ) || media?.type === "Onedrive" || media?.type === "dropbox" ) && (
                <img
                    style={ { objectFit: 'contain', backgroundColor: isComment ? 'white' : '#eeeeee' } }
                    src={ media?.type === "dropbox" ? media?.orgFile : media?.linkURL || Media.getURL( media ) }
                    alt=""
                />
            ) }
            { media?.type?.startsWith( 'application' ) && (
                <>
                    { isPreview && (
                        <AHStack position="absolute" right="3%" top="-1%" zIndex={ 9999 } >
                            <Pressable onPress={ () => handledocument( item ) }>
                                <DownloadIcon height="25px" width="25px" color="#000000" />
                            </Pressable>
                        </AHStack>
                    ) }

                <img src={
                    ( media?.type === 'application/pdf' && settings.pdf ) ||
                    ( ( media?.type === 'application/msword' || media?.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ) && settings.word ) ||
                    ( ( media?.type === 'application/vnd.ms-powerpoint' || media?.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ) && settings.powerpoint ) ||
                    ( ( media?.type === 'application/vnd.ms-excel' || media?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ) && settings.excel ) ||
                    settings.file
                } alt="" />
                </>
            ) }
            { media?.type === "text/plain" && (
               <img src={settings.file} alt="" />
            ) }
            { media?.type?.startsWith( 'video' ) && media?.linkURL && (
                <video controls>
                    <source src={ media?.linkURL } type="video/mp4" />
                </video>
            ) }
            { media?.type === "iframe" && (
                <iframe
                    src={ media?.linkURL }
                    title="Embedded content"
                    frameBorder="0"
                    allowFullScreen
                ></iframe>
            ) }
            { media?.type?.startsWith( 'video' ) && !media?.linkURL && (
                //<div className="processing-container">
                //    <img src={ Media.getVideoPicURL( media ) } alt="Processing" style={ { objectFit: 'contain', backgroundColor: isComment ? 'white' : '#eeeeee' } } />
                    <ProcessingVideo media={media} item={item} setVideoStatus={setVideoStatus} setVideoItem={setVideoItem} isComment={isComment} isConvoReply={isConvoReply}/>
                //</div>
            ) }
            { media?.type === "linkPreview" && (
                <SimpleLinkPreview url={ media } />
            ) }
            { index === 4 && post?.media?.length > 5 && (
                <div className="media-overlay">
                    +{ post?.media?.length - 5 }
                </div>
            ) }
        </div>
    ), [ item?.type ] );


    if ( isOpening )
    {
        return (
            <HStack space={ 2 } alignItems='center' justifyContent={ 'center' } w={ '100%' } height={ '300px' }>
                <Spinner accessibilityLabel={ Loc.currentLang.alertType.openingDocument } />
                <Heading color='primary.500' fontSize='md'>
                    { Loc.currentLang.alertType.openingFile }
                </Heading>
            </HStack>
        );
    }

    return (
        <div>
            { posts.map( ( post, index ) => (
                <div key={ post?.id + index } className="post-card">
                    <div className={ `media-grid grid-${ Math.min( post?.media?.length, 5 ) }` }>
                        { post.media.slice( 0, 5 ).map( ( media, mediaIndex ) => renderMediaItem( media, mediaIndex, post, isPreview, isConvoReply ) ) }
                    </div>
                </div>
            ) ) }
        </div>
    );
} );

export default GridView;